import { calmTokens as t } from '../../../shared/tokens';
import { IconUndo } from '../../../shared/icons';
import { Chip, PillButton, Stat } from './ui';
import { LABEL_STATUS_KINDS } from '../../../shared/labels';

function llmCost(llm) {
  if (!llm || !llm.calls) return null;
  return `${llm.calls} appel${llm.calls > 1 ? 's' : ''} · ${llm.inputTokens} + ${llm.outputTokens} tokens`;
}

/** Provenance des libellés des lignes créées : règles, classifieur, Claude, inconnus. */
function LabelSources({ byStatus }) {
  if (!byStatus) return null;
  const parts = [
    ['règle', byStatus.rule, LABEL_STATUS_KINDS.rule],
    ['classifieur', byStatus.classifier, LABEL_STATUS_KINDS.classifier],
    ['Claude', byStatus.llm, LABEL_STATUS_KINDS.llm],
    ['corrigé', byStatus.confirmed, LABEL_STATUS_KINDS.confirmed],
    ['inconnu', byStatus.unmatched, LABEL_STATUS_KINDS.unmatched],
  ].filter(([, n]) => n > 0);
  if (!parts.length) return null;
  return (
    <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap', alignItems: 'center', marginTop: 12 }}>
      <span style={{ fontSize: 11, color: t.textMute, marginRight: 4 }}>Libellés des nouvelles :</span>
      {parts.map(([label, n, kind]) => (
        <Chip key={label} kind={kind}>
          {n} {label}
        </Chip>
      ))}
    </div>
  );
}

/** Résumé des statistiques d'un aperçu ou d'un import. */
export function StatsRow({ stats, llm }) {
  if (!stats) return null;
  const cost = llmCost(llm || stats.llm);
  return (
    <div>
      <div style={{ display: 'flex', gap: 22, flexWrap: 'wrap', alignItems: 'flex-end' }}>
        <Stat label="Lignes" value={stats.total} />
        <Stat label="Nouvelles" value={stats.created} accent={t.credit} />
        <Stat label="Rapprochées" value={stats.matched} accent={t.accent} />
        <Stat label="Déjà importées" value={stats.skippedDuplicates} accent={t.textMute} />
        <Stat label="À vérifier" value={(stats.byStatus?.llm || 0) + (stats.byStatus?.unmatched || 0)} accent={t.warn} />
        {stats.recurringMatched > 0 && <Stat label="Récurrentes" value={stats.recurringMatched} />}
        {cost && (
          <span style={{ fontSize: 11, color: t.textMute, marginLeft: 'auto', alignSelf: 'center' }}>Claude : {cost}</span>
        )}
      </div>
      <LabelSources byStatus={stats.byStatus} />
    </div>
  );
}

/** Écran de fin d'import avec lien d'annulation. */
export default function ImportSummary({ batch, onCancel, onNew, busy }) {
  if (!batch) return null;
  return (
    <div>
      <div
        style={{
          padding: '14px 16px',
          background: 'rgba(134,239,172,0.06)',
          border: `1px solid ${t.creditBorder}`,
          borderRadius: 14,
          marginBottom: 14,
        }}
      >
        <div style={{ fontSize: 14, fontWeight: 500, color: t.credit, marginBottom: 10 }}>
          Import terminé{batch.fileName ? ` · ${batch.fileName}` : ''}
        </div>
        <StatsRow stats={batch.stats} />
      </div>
      <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
        <PillButton primary onClick={onNew} disabled={busy}>
          Importer un autre fichier
        </PillButton>
        {batch.status === 'committed' && (
          <PillButton danger icon={<IconUndo size={13} />} onClick={() => onCancel(batch._id)} disabled={busy}>
            Annuler cet import
          </PillButton>
        )}
      </div>
    </div>
  );
}
